import { render, staticRenderFns } from "./TaskPreview.component.vue?vue&type=template&id=6f479b5a&scoped=true&"
import script from "./TaskPreview.component.vue?vue&type=script&lang=js&"
export * from "./TaskPreview.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskPreview.component.vue?vue&type=style&index=0&id=6f479b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f479b5a",
  null
  
)

export default component.exports